/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsUserSerialNumberReminder
 */
export interface MelcoModelsUserSerialNumberReminder {
    /**
     * 
     * @type {boolean}
     * @memberof MelcoModelsUserSerialNumberReminder
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserSerialNumberReminder
     */
    email_list?: string | null;
}

export function MelcoModelsUserSerialNumberReminderFromJSON(json: any): MelcoModelsUserSerialNumberReminder {
    return MelcoModelsUserSerialNumberReminderFromJSONTyped(json, false);
}

export function MelcoModelsUserSerialNumberReminderFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsUserSerialNumberReminder {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'email_list': !exists(json, 'email_list') ? undefined : json['email_list'],
    };
}

export function MelcoModelsUserSerialNumberReminderToJSON(value?: MelcoModelsUserSerialNumberReminder | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'email_list': value.email_list,
    };
}


